import { useContext } from "react";
import { GuildSettingsContext } from "../../guild_settings";

export function ChannelTag(props: { name: string } | { id: string }) {
	const { all_text_channels } = useContext(GuildSettingsContext);

	const name =
		"name" in props
			? props.name
			: "id" in props
			? all_text_channels.find((channel) => channel.id === props.id)?.name
			: "Error";

	return (
		<span
			className="tag tag-dark-gray gap-2 sm:max-w-[45%] max-w-full min-w-0"
			title={`sesh - #${name}`}
		>
			<span className="sesh-text">sesh</span>{" "}
			<span className="has-text-weight-bold truncate">#{name}</span>
		</span>
	);
}
